import React from 'react';
import { Step } from 'react-joyride';

import SZJoyride from '@buyside/components/presentation/Joyride/szJoyride';
import { activityFeedJoyrideSteps } from '@buyside/components/presentation/Joyride/ActivityFeedJoyride/activityFeedJoyrideHelper';

import { optOutJoyride, shouldHideJoyride } from '@buyside/util/joyrideUtil';

import { useIsMobile } from '@buyside/util/hooks/useIsMobile';
import { useActivityFeedJoyrideQuery } from '@interfaces/graphql-typings';

const joyrideCookieName = 'hideActivityFeedJoyride';

const ActivityFeedJoyride: React.FC = () => {
  const isMobile = useIsMobile();

  const { data, loading } = useActivityFeedJoyrideQuery();

  if (shouldHideJoyride(joyrideCookieName) || loading || isMobile) return null;

  const steps: Step[] = [
    ...(data?.currentUser?.canViewIdeas ? [activityFeedJoyrideSteps.researchTab] : []),
    activityFeedJoyrideSteps.membersTab
  ];

  return (
    <SZJoyride
      callback={({ status }): void => optOutJoyride(status, joyrideCookieName)}
      continuous
      spotlightClicks
      steps={steps}
    />
  );
};

export default ActivityFeedJoyride;
